/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DestinatarioRicercaDTO { 
    /**
     * Identificativo del cittadino.
     */
    id?: string;
    /**
     * Nome; assente se non disponibile.
     */
    nome?: string;
    /**
     * Cognome; assente se non disponibile.
     */
    cognome?: string;
    /**
     * Email del cittadino; assente se non ne ha una.
     */
    email?: string;
    /**
     * Vero se il cittadino ha un\'email.
     */
    ha_email?: boolean;
    /**
     * Numero di dispositivi con un token push registrato: zero significa che una push non lo raggiungerebbe.
     */
    n_dispositivi?: number;
}

